const getCamera = () => {
  const camera = new THREE.PerspectiveCamera(
    45,
    window.innerWidth / window.innerHeight,
    1,
    50000
  );

  camera.position.x = 8000;
  camera.position.y = 5000;
  camera.position.z = 5000;

  return camera;
};

export default getCamera;
